import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

import { RobotoTooltip } from "@/shared/components";
import { Button } from "@/shared/foundation/primitives";

import styles from "./InvokeSkillButton.module.css";

interface Props {
  /** Insert a `/` at the current textarea cursor and bring focus to it,
   * which causes the composer's autocomplete to open. */
  onTriggerAutocomplete: () => void;
}

/**
 * Toolbar affordance that *opens* the slug autocomplete inside
 * :class:`SkillSlugComposer` by inserting a `/` at the current caret.
 *
 * Discovery-focused: power users will type `/` themselves; this is the
 * pointing-device path to the same outcome. There is no version dropdown or
 * chip metadata to manage — once the user picks a skill in autocomplete the
 * slug becomes part of the message text.
 */
export function InvokeSkillButton({ onTriggerAutocomplete }: Props) {
  return (
    <RobotoTooltip title="Insert a / to invoke a skill">
      <Button
        size="small"
        variant="text"
        className={styles.button}
        onClick={onTriggerAutocomplete}
        startIcon={<AutoAwesomeIcon className={styles.smallIcon} />}
      >
        Skills
      </Button>
    </RobotoTooltip>
  );
}
